/** @jsxImportSource @emotion/react */
import { usePrioritisationContext } from '@app/contexts/ModuleContexts/PrioritisationContext'
import { usePrioritisationMap } from '@app/contexts/ModuleMapContexts/PrioritisationMapContext'
import { Box, useTheme } from '@mui/material'
import { PrioritisationMapView } from '@app/components/Molecules/MapView/PrioritisationMapView'
import { SideDrawer } from '@app/components/Molecules/SideDrawer'
import { SideDrawerContent } from '@app/components/PrioritisationPage/SideDrawerContent'
import { WizardModal } from '@app/components/PrioritisationPage/WizardModal'
import { useQueryParam } from '@app/hooks/useQueryParam'
import { useEffect, useState } from 'react'
import { prioritisationPageContainer, sideDrawerContainer } from './PrioritisationPage.styles'
import { useLayerDataFetcher } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDataFetcher'

export const PrioritisationPage = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true)
  const theme = useTheme()
  const layersData = useLayerDataFetcher()
  const mapContext = usePrioritisationMap()
  const { setMapPadding, flyTo, map, getMapPadding } = mapContext
  const { initializePrioritisation } = usePrioritisationContext()

  const wizardParam = useQueryParam('wizard')
  const [wizardIsOpen, setWizardIsOpen] = useState(wizardParam === 'true')

  useEffect(() => {
    if (layersData) initializePrioritisation()
  }, [initializePrioritisation, layersData])

  // TODO: handle fullscreen changes

  return (
    <Box css={prioritisationPageContainer} id="prioritisationPageContainer">
      <Box css={sideDrawerContainer}>
        <SideDrawer
          isOpen={isDrawerOpen}
          mapContext={mapContext}
          handleToggle={() => setIsDrawerOpen(!isDrawerOpen)}
          color={theme.palette.primary.main}
          side="left"
          initialWidth={600}
          handleWidthChange={(width: number) => {
            const { left: previousWidth } = getMapPadding(true)
            setMapPadding({ top: 0, left: width, bottom: 0, right: 0 })

            if (map && width != previousWidth) {
              flyTo({
                latitude: map.getCenter().lat,
                longitude: map.getCenter().lng,
                zoom: map.getZoom(),
                usePadding: true,
                duration: 800,
              })
            }
          }}
        >
          <SideDrawerContent
            openWizard={() => {
              setWizardIsOpen(true)
            }}
            hideContent={wizardIsOpen}
          />
        </SideDrawer>
      </Box>
      {layersData && <PrioritisationMapView />}
      {wizardIsOpen && (
        <WizardModal
          open={wizardIsOpen}
          completeWizard={() => {
            setWizardIsOpen(false)
          }}
          returnFromWizard={() => {
            setWizardIsOpen(false)
            const url = new URL(window.location.href)
            if (url.searchParams.get('wizard') === 'true') {
              url.searchParams.delete('wizard')
              window.history.replaceState({}, '', url.toString())
            }
          }}
        />
      )}
    </Box>
  )
}
